import { AnalyticsBrowser, type AnalyticsBrowserSettings, type InitOptions } from "@segment/analytics-next";
import { createContext } from "react";

import { isProduction } from "@/utils/environment-detection";
import webConfig from "@/web-config";

export type SegmentContextValue = {
    analytics?: AnalyticsBrowser;
    platformDetails?: {
        platform?: string;
        architecture?: string;
    };
};

export const SegmentContext = createContext<SegmentContextValue | undefined>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export function createSegment(): SegmentContextValue {
    // Remove legacy Segment localStorage key that is no longer created but may still exist
    try {
        localStorage.removeItem("ajs_user_traits");
    } catch {
        // Ignore errors if localStorage is unavailable
    }

    const originURL = new URL(webConfig.origin);
    const segmentSettings: AnalyticsBrowserSettings = {
        cdnURL: webConfig.origin + "/segment",
        writeKey: isProduction() ? "g5Dgcf8kFxV7EPvOp7gGcJhH0FAwE1GW" : "Gb48f7bya7dVEGSj4zlhB4Ssc3hYTpBS",
    };
    const segmentConfig: InitOptions = {
        // Use Cookie + Memory storage to:
        // - Keep anonymousId in cookies (survives OAuth redirects)
        // - Store traits in memory only (no localStorage, preventing email storage)
        storage: {
            stores: ["cookie", "memory"],
        },
        user: {
            localStorageFallbackDisabled: true,
        },
        integrations: {
            "Segment.io": {
                apiHost: originURL.host + "/segment/v1",
                protocol: originURL.protocol.replace(":", ""),
            },
        },
        highEntropyValuesClientHints: [
            "architecture",
            "bitness",
            "model",
            "platformVersion",
            "uaFullVersion",
            "fullVersionList",
            "wow64",
        ],
    };
    const analytics = AnalyticsBrowser.load(segmentSettings, segmentConfig);
    return { analytics };
}
